import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['datepicker']

  updateDatepicker(event) {
    const year = event.target.value

    this.datepickerTargets.forEach(element => {
      const currentDate = element._flatpickr.selectedDates[0]
      const newDate = new Date(year, currentDate.getMonth(), currentDate.getDate())

      element._flatpickr.setDate(newDate, true, 'Y-m-d')
    })
  }
}
